import { motion } from 'framer-motion';

const ease = [0.16, 1, 0.3, 1];

export default function Intro() {
  return (
    <section className="bg-[hsl(var(--cream-2))]/70 border-b border-[hsl(var(--hairline))]/70">
      <div className="max-w-5xl mx-auto px-6 lg:px-12 py-28 lg:py-36">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.9, ease }}
          className="text-overline mb-10"
        >
          The Studio
        </motion.div>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 1.05, ease }}
          className="font-display text-[1.75rem] sm:text-3xl lg:text-[2.5rem] leading-[1.15] max-w-3xl"
        >
          Vancouver&apos;s go-to lash lift studio —
          <span className="italic text-[hsl(var(--primary))] font-medium"> no extensions required.</span>
        </motion.h2>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 1, ease, delay: 0.12 }}
          className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-16 text-[hsl(var(--muted-foreground))] text-[0.98rem] lg:text-[1.05rem] leading-[1.85]"
        >
          <p>
            A lash lift is the ultimate low-maintenance beauty treatment. No glue. No
            extensions. No daily curling. Just your own natural lashes, lifted from the
            root and set in place for up to 12 weeks.
          </p>
          <p>
            At Prép Beauty Parlour on Burrard Street, we offer two of the world&apos;s leading
            lash lift systems — YUMI Keratin Lash Lift (France) and InLei Lash Filler®
            (Italy). Both are performed by certified lash artists in our calm downtown
            Vancouver studio.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
